'use client'
import { type ReactNode } from 'react'
import { type PriceTemplate } from '@/services/PriceCalculator/PriceCalculator.types'
import { useSyncPriceTemplate } from '../PurchaseForm/priceTemplateAtom'

type Props = {
  priceTemplate: PriceTemplate
  children: ReactNode
}
export function PriceTemplateProvider({ priceTemplate, children }: Props) {
  useSyncPriceTemplate(priceTemplate)
  return children
}
